import { render, staticRenderFns } from "./nav-step-icon.vue?vue&type=template&id=5d339fc5&scoped=true&"
import script from "./nav-step-icon.vue?vue&type=script&lang=ts&"
export * from "./nav-step-icon.vue?vue&type=script&lang=ts&"
import style0 from "./nav-step-icon.vue?vue&type=style&index=0&id=5d339fc5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d339fc5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDivider,VIcon})
